import { ContactControllerModel } from '../controller_model/contact';
import { DistributionListControllerModel } from '../controller_model/distributionList';
import { GroupControllerModel } from '../controller_model/group';
import { MeControllerModel } from '../controller_model/me';
export class ControllerModelService {
    $translate;
    $mdDialog;
    logService;
    webClientService;
    log;
    static $inject = ['$translate', '$mdDialog', 'LogService', 'WebClientService'];
    constructor($translate, $mdDialog, logService, webClientService) {
        this.$translate = $translate;
        this.$mdDialog = $mdDialog;
        this.logService = logService;
        this.webClientService = webClientService;
        this.log = logService.getLogger('ControllerModel-S');
    }
    me(receiver, mode) {
        return new MeControllerModel(this.$translate, this.$mdDialog, this.logService, this.webClientService, mode, receiver);
    }
    contact(receiver, mode) {
        return new ContactControllerModel(this.$translate, this.$mdDialog, this.logService, this.webClientService, mode, receiver);
    }
    group(receiver, mode) {
        return new GroupControllerModel(this.$translate, this.$mdDialog, this.logService, this.webClientService, mode, receiver);
    }
    distributionList(receiver, mode) {
        return new DistributionListControllerModel(this.$translate, this.$mdDialog, this.logService, this.webClientService, mode, receiver);
    }
}
